import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import { BASE_URL } from "../../config/axios";
import { ToastContainer, toast } from "react-toastify";
import Dashboardnavbar from "../../layout/Dashboardnavbar";
import { AddwithWhiteCircle, DeleteDustbin, UpdatePencil } from "../AllSvg";
import { handleErrorToast } from "../CustomFunctions";
import { Eye } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { AddCv } from "./Cv"


const AddDesignation = ({ getDesignation }) => {
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({ name: "" });
    const [errors, setErrors] = useState({});

    const handleClose = () => {
        setFormData({ name: "" });
        setErrors({});
        setShow(false);
    };

    const validateForm = () => {
        let newErrors = {};
        if (!formData.name.trim()) {
            newErrors.name = "Name is required!";
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) return;

        setLoading(true);
        const loadingToastId = toast.loading("Loading: Please wait...");

        try {
            let res = await axios.post(
                `${BASE_URL}/siteproject/designationforbd/`,
                formData
            );

            if (res.status === 200 || res.status === 201) {
                await getDesignation();
                handleClose();
                toast.success("Designation added successfully!");
            } else {
                toast.error("Failed to add designation!");
            }
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <button
                title="Add Designation"
                className="upload-svg"
                onClick={() => setShow(true)}
            >
                <AddwithWhiteCircle /> Designation
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="request-leave">
                <Modal.Header closeButton>
                    <Modal.Title>Add Designation</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div className="flex-column">
                        <label className="form-labels font-weight500">
                            Name<span className="required">*</span>
                        </label>
                        <input
                            type="text"
                            placeholder="Enter designation name"
                            value={formData.name}
                            onChange={(e) =>
                                setFormData({ ...formData, name: e.target.value })
                            }
                            className={`form-input ${errors.name ? "error" : ""}`}
                        />
                        {errors.name && (
                            <span className="error-message">{errors.name}</span>
                        )}
                    </div>

                    <div className="button-models">
                        <button
                            className="model-button model-button-cancel"
                            onClick={handleClose}
                        >
                            Cancel
                        </button>

                        <button
                            className="model-button model-button-leave"
                            onClick={handleSubmit}
                            disabled={loading}
                        >
                            Add
                        </button>
                    </div>

                    <ToastContainer position="top-center" autoClose={1000} />
                </Modal.Body>
            </Modal>
        </>
    );
};



const UpdateDesignation = ({ item, getDesignation }) => {
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({ name: "" });
    const [errors, setErrors] = useState({});

    const handleShow = () => {
        setFormData({ name: item.name });
        setShow(true);
    };

    const handleClose = () => {
        setFormData({ name: "" });
        setErrors({});
        setShow(false);
    };

    const validateForm = () => {
        let newErrors = {};
        if (!formData.name.trim()) {
            newErrors.name = "Name is required!";
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        setLoading(true);
        const loadingToastId = toast.loading("Loading: Please wait...");

        try {
            let res = await axios.put(
                `${BASE_URL}/siteproject/designationforbd/${item.id}/`,
                formData
            );

            if (res.status === 200) {
                await getDesignation();
                handleClose();
                toast.success("Designation updated successfully!");
            } else {
                toast.error("Failed to update designation!");
            }
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <button
                title="Update Designation"
                className="model-edit-button"
                onClick={handleShow}
            >
                <UpdatePencil />
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="request-leave">
                <Modal.Header closeButton>
                    <Modal.Title>Update Designation</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div className="flex-column">
                        <label className="form-labels font-weight500">
                            Name<span className="required">*</span>
                        </label>
                        <input
                            type="text"
                            value={formData.name}
                            onChange={(e) =>
                                setFormData({ ...formData, name: e.target.value })
                            }
                            className={`form-input ${errors.name ? "error" : ""}`}
                        />
                        {errors.name && (
                            <span className="error-message">{errors.name}</span>
                        )}
                    </div>

                    <div className="button-models">
                        <button
                            className="model-button model-button-cancel"
                            onClick={handleClose}
                        >
                            Cancel
                        </button>

                        <button
                            className="model-button model-button-leave"
                            onClick={handleSubmit}
                            disabled={loading}
                        >
                            Update
                        </button>
                    </div>

                    <ToastContainer position="top-center" autoClose={1000} />
                </Modal.Body>
            </Modal>
        </>
    );
};




const DeleteDesignation = ({ item, getDesignation }) => {
    const [show, setShow] = useState(false);

    const handleDelete = async () => {
        const loadingToastId = toast.loading("Loading: Please wait...");

        try {
            let res = await axios.delete(
                `${BASE_URL}/siteproject/designationforbd/${item.id}/`
            );

            if (res.status === 200) {
                await getDesignation();
                toast.success("Designation deleted successfully!");
                setShow(false);
            }
        } catch (err) {
            handleErrorToast(err);
        } finally {
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <button
                title="Delete Designation"
                className="model-delete-button"
                onClick={() => setShow(true)}
            >
                <DeleteDustbin />
            </button>

            <Modal show={show} onHide={() => setShow(false)} dialogClassName="request-leave width-40vw">
                <Modal.Header closeButton>
                    <Modal.Title>
                        Delete Designation "{item.name}"
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div className="parent-div">
                        Are you sure you want to delete?
                        <div className="button-models">
                            <button
                                className="model-button model-button-cancel"
                                onClick={() => setShow(false)}
                            >
                                Cancel
                            </button>

                            <button
                                className="model-button model-button-delete"
                                onClick={handleDelete}
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};


// ========================= MAIN PAGE =========================

const Designation = () => {
    const [buffer, setBuffer] = useState(true);
    const [designationData, setDesignationData] = useState([]);
    const navigate = useNavigate();
    const ViewAllBidDetails = (project, data) => {
        navigate(`/${window.location?.pathname?.split("/")[1] || "certificaionadminaccess"}/cv/`, {
            state: { project, data }
        });
    };
    const getDesignation = async () => {
        setBuffer(true);
        try {
            const res = await axios.get(
                `${BASE_URL}/siteproject/designationforbd/`
            );
            setDesignationData(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffer(false);
        }
    };
    const [CvData, setCvData] = useState([]);
    const getCv = async () => {

        try {
            const response = await axios.get(`${BASE_URL}/siteproject/cvdesignation/null/`);
            setCvData(response.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {

        }
    };
    useEffect(() => {
        getDesignation();
    }, []);

    return (
        <>
            {/* <Dashboardnavbar name="Designation" url="Designation" /> */}

            <div className="">
                <div className="table-css-white-background" style={{ padding: "34px 30px" }}>
                    <div className="table-heading-flex">
                        <div className="repo-heading font-weight500 font-size-heading">
                            Designation
                        </div>

                        <AddDesignation getDesignation={getDesignation} />
                    </div>

                    <div className="table-box height-73vh">
                        <table className="table-css">
                            <thead className="table-heading">
                                <tr>
                                    <th className="align-left">Sr.No.</th>
                                    <th className="align-center">Name</th>

                                    <th className="align-center width-5vw">Action</th>
                                </tr>
                            </thead>

                            {buffer ? (
                                <div className="spinner-bgdatil"></div>
                            ) : (
                                <tbody>
                                    {designationData.map((item, index) => (
                                        <tr key={index}>
                                            <td className="align-left">
                                                {index + 1}
                                            </td>
                                            <td className="align-center">
                                                {item.name}
                                            </td>

                                            <td className="align-center">
                                                <div className="flex-row justify-evenly" style={{ gap: '10px' }}>
                                                    <span onClick={() => ViewAllBidDetails(item.id, item)} style={{ cursor: 'pointer' }}><Eye /></span>
                                                    <UpdateDesignation
                                                        item={item}
                                                        getDesignation={getDesignation}
                                                    />
                                                    <DeleteDesignation
                                                        item={item}
                                                        getDesignation={getDesignation}
                                                    />
                                                    <AddCv designationid={item.id} getCv={getCv} showname={false} />
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            )}
                        </table>
                    </div>

                    <ToastContainer position="top-center" autoClose={1000} />
                </div>
            </div>
        </>
    );
};

export default Designation;